import { h, FunctionComponent } from 'preact'
import { useEffect, useState } from 'preact/hooks'
import styles from './styles.module.scss'
import { VideoFeedback } from '../Common/VideoFeedback'
import { options } from '../types'
import { LivenessError } from '../VideoCapture/errors'

interface SuccessData {
  videoPayload: Blob
}

interface Props {
  onError: (event: LivenessError) => void
  onSuccess: (event: SuccessData) => void
  debug: boolean
  options: options
}

export const ActiveVideoCapture: FunctionComponent<Props> = ({
  onError,
  onSuccess,
  debug,
  options,
}: Props) => {
  const [videoPayload, setVideoPayload] = useState<Blob>()

  useEffect(() => {
    if (videoPayload) onSuccess?.({ videoPayload })
  }, [videoPayload, onSuccess])

  return (
    <div className={styles.wrapper}>
      <VideoFeedback
        debug={debug}
        options={options}
        landscape={false}
        setVideoPayload={setVideoPayload}
        onError={onError}
      />
    </div>
  )
}
